import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { APP_CONFIG, AppConfig } from '@cco-apps/cco-frontend';
import { Observable } from 'rxjs';

export function sendCredentialsInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const appConfig = inject<AppConfig>(APP_CONFIG);

  if (req.url.startsWith(appConfig.apiBaseUrl)) {
    return next(req.clone({
      withCredentials: true,
      setHeaders: acceptJsonHeader(req),
    }));
  }

  return next(req);
}

/**
 * Asks for JSON, which is what makes an expired edge auth session recoverable.
 *
 * oauth2-proxy answers an unauthenticated request with a 302 to the identity
 * provider; a cross-origin XHR cannot follow that, so the app only ever sees a
 * status 0 network failure. Requesting JSON opts into the proxy's API behaviour,
 * where it answers 401 instead -- which the interceptors already know how to act
 * on.
 *
 * Left alone when the caller chose its own Accept, or when the response is not
 * JSON: exports (PDF, CSV, images) would invite a 406 from a content-negotiating
 * backend.
 */
function acceptJsonHeader(req: HttpRequest<unknown>): Record<string, string> {
  const negotiable = req.responseType === 'json' && !req.headers.has('Accept');

  return negotiable ? { Accept: 'application/json' } : {};
}
